import type { PageLoad } from './$types';
import { toDynamicStylesTag } from '$lib/helpers/dynamic-css-helpers';
import { loadDynamicBundlesToComponentLibStore } from '$lib/helpers/component-import-map';

export const load: PageLoad = async ({ data: { bundles, dynamicCss, ...rest } }) => {
  await loadDynamicBundlesToComponentLibStore(bundles);

  return {
    ...rest,
    bundles,
    dynamicStyles: toDynamicStylesTag(dynamicCss),
  };
};
